import { lazy } from "react";

const routes = [
  {
    path: "/hub",
    element: lazy(() => import("../pages/Hub")),
  },
  {
    path: "/hub/add",
    element: lazy(() => import("../pages/Hub/create")),
  },
  {
    path: "/hub/edit/:id",
    element: lazy(() => import("../pages/Hub/edit")),
  },
];

export default routes;
